import model from './model'
import input from './input'
import appBar from './appBar'
import bottomNav from './bottomNav'
import appState from './appState'
import snackBar from './snackBar'
import section from './section'
import alert from './alert'

export default {
    alert,
    model,
    input,
    bottomNav,
    snackBar,
    section,
    hideMenu: appBar.hideMenu,
    showTitle: appBar.showTitle,
    renderEvent: appState.renderEvent,
}

export {
    alert,
    model,
    input,
    appBar,
    bottomNav,
    appState,
    snackBar,
    section
}


